import React from 'react'
import { Outlet } from 'react-router-dom';

const SimpleLayout = () => {
  return (
    <div style={{background:'#BFD4E1'}}>
        <Outlet />
    </div>
  )
}

export default SimpleLayout